import React from "react";
import { Phone, MessageCircle, Zap, Shield, Clock, DollarSign } from "lucide-react";
import { BUSINESS, WHATSAPP_URL, TEL_PRIMARY, IMAGES } from "../lib/business";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative isolate min-h-[100vh] md:min-h-[92vh] flex items-center pt-24 md:pt-28 pb-12 overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0 -z-10">
        <img
          src={IMAGES.autoCenter}
          alt="Caminhão guincho da Refúgio Guincho em frente ao Centro Automotivo em Araçoiaba da Serra"
          className="w-full h-full object-cover object-center"
          loading="eager"
          fetchPriority="high"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/40 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A]/85 via-[#0A0A0A]/30 to-transparent" />
      </div>

      {/* Siren light top-left ambient */}
      <div className="absolute top-28 left-4 w-3 h-3 md:w-4 md:h-4 rounded-full bg-[#E50914] siren-light -z-[5]" aria-hidden />

      <div className="max-w-7xl mx-auto px-4 md:px-8 w-full">
        <div className="max-w-3xl">
          {/* Urgency tag */}
          <div className="inline-flex items-center gap-2 bg-[#E50914] px-4 py-2 mb-6 rounded-sm">
            <span className="w-2 h-2 rounded-full bg-white siren-light" aria-hidden />
            <span className="font-anton text-sm md:text-base text-white uppercase tracking-widest">
              24 Horas · Atendimento Humanizado
            </span>
          </div>

          <h1
            data-testid="hero-headline"
            className="font-anton text-5xl sm:text-6xl md:text-7xl lg:text-[5.5rem] uppercase text-white leading-[0.95] mb-4"
          >
            Guincho <span className="text-[#E50914]">24 Horas</span>
            <br />
            <span className="block text-4xl sm:text-5xl md:text-6xl lg:text-7xl">Araçoiaba da Serra e Região</span>
          </h1>

          <p className="font-anton text-lg md:text-2xl text-white uppercase tracking-wide mb-3">
            Atendimento Rápido <span className="text-[#E50914]">•</span> Menor Preço Garantido
          </p>
          <p className="font-anton text-base md:text-xl text-[#E50914] uppercase tracking-wide mb-6">
            O menor preço garantido — cota com a gente!!!
          </p>

          <p className="font-work text-base md:text-lg text-zinc-200 mb-8 max-w-2xl leading-relaxed">
            <strong className="text-white">Parou? Quebrou? Chamou, chegou Refúgio Guincho!</strong> Chegamos rápido até você com segurança, cuidado com seu veículo e preço justo. Remoção de carros, motos e transporte de materiais em Araçoiaba da Serra, Sorocaba, Votorantim, São Paulo e toda região.
          </p>

          {/* Massive CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 mb-10">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-whatsapp-button"
              className="relative group bg-[#25D366] hover:bg-[#1EBE5D] text-white font-anton uppercase text-xl md:text-2xl tracking-wider px-8 py-5 flex items-center justify-center gap-3 rounded-sm transition-all hover:-translate-y-1 shadow-[0_10px_40px_rgba(37,211,102,0.4)]"
            >
              <MessageCircle className="w-6 h-6 md:w-7 md:h-7" strokeWidth={2.5} />
              Chamar no WhatsApp
            </a>
            <a
              href={TEL_PRIMARY}
              data-testid="hero-ligar-agora-button"
              className="relative group bg-[#E50914] hover:bg-[#B80710] text-white font-anton uppercase text-xl md:text-2xl tracking-wider px-8 py-5 flex items-center justify-center gap-3 rounded-sm transition-all hover:-translate-y-1 shadow-[0_10px_40px_rgba(229,9,20,0.5)]"
            >
              <Phone className="w-6 h-6 md:w-7 md:h-7" strokeWidth={2.5} />
              Ligar Agora
            </a>
          </div>

          {/* Quick trust badges */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6">
            {[
              { icon: Zap, label: "Atendimento Imediato" },
              { icon: Clock, label: "24h · 7 dias" },
              { icon: DollarSign, label: "Menor Preço" },
              { icon: Shield, label: "Total Segurança" },
            ].map(({ icon: Icon, label }) => (
              <div key={label} className="flex items-center gap-2 border-l-2 border-[#E50914] pl-3">
                <Icon className="w-5 h-5 md:w-6 md:h-6 text-[#E50914]" strokeWidth={2.5} />
                <span className="font-work font-bold text-xs md:text-sm text-white uppercase tracking-wide leading-tight">
                  {label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
